import { createSlice } from "@reduxjs/toolkit";
import { mergeWageringMember } from "../../utils/wagering";
export const memberSlice = createSlice({
  name: "member",
  initialState: {
    member: {},
    login: false,
    credit: 0,
    loggedIn: false,
    imglogo: "",
    lastDeposit: null,
    dataAff: {},
  },
  reducers: {
    setMember: (state, action) => {
      state.login = true;
      state.member = mergeWageringMember(state.member, action.payload);
      if (state.member?.wagering_status) state.credit = Number(state.member.credit);
    },
    setLogOut: (state, action) => {
      state.login = false;
      state.member = {};
    },
    setCredit: (state, action) => {
      if (!state.member?.wagering_status) state.credit = action.payload;
    },
    setloggedIn: (state, action) => {
      state.loggedIn = action.payload;
    },
    setimglogo: (state, action) => {
      state.imglogo = action.payload;
    },
    setLastDeposit: (state, action) => {
      state.lastDeposit = action.payload;
    },
    setDataAff: (state, action) => {
      state.dataAff = action.payload;
    },
  },
});

export const {
  setMember,
  setLogOut,
  setCredit,
  setloggedIn,
  setimglogo,
  setLastDeposit,
  setDataAff,
} = memberSlice.actions;
export const getMember = (state) => state.member.member;
export const getLogin = (state) => state.member.login;
export const getCredit = (state) => state.member.credit;
export const getLoggedIn = (state) => state.member.loggedIn;
export const getimglogo = (state) => state.member.imglogo;
export const getLastDeposit = (state) => state.member.lastDeposit;
export const getDataAff = (state) => state.member.dataAff;

export default memberSlice.reducer;
